























































































































































































































































































































































































































































































































































































































































































































































































// --- Vue & Template imports ---
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BaseMaterialCard from '@/components/base/MaterialCard.vue';
import ConfirmActionDialog from './components/ConfirmActionDialog.vue';

// --- Models ---
import { DisabledIDNamePair, IDNamePair } from '@/models/App.model';
import { LoggedInUser, UserInformation } from '@/models/User.model';
import { SubjectMarkPair } from '@/models/Subject.model';

// --- Services ---
import AppService from '@/services/app';
import AuthService from '@/services/auth';

// --- Third Party imports ---
import dayjs from 'dayjs';

@Component({
  components: {
    BaseMaterialCard,
    ConfirmActionDialog,
  },
})
export default class UserProfileForm extends Vue {
  profileValid: boolean = false;
  infoValid: boolean = false;
  subjectFormValid: boolean = false;

  // used by loaders
  updateProfileLoader: boolean = false;
  updateInfoLoader: boolean = false;
  passwordResetLoader: boolean = false;

  clickedItem: LoggedInUser = {
    loggedIn: true,
    displayName: '',
    email: '',
    registered: false,
    isMomentumMember: false,
    paid: false,
    testComplete: false,
    profile: {
      firstName: '',
      surname: '',
      email: '',
      username: '',
      wantsNews: false,
      quote: '',
    },
  };

  today: string = dayjs().format('YYYY-MM-DD');
  dobPicker: boolean = false;
  dateOfBirth: string = '';

  rules = {
    required: (value: string) => !!value || '',
    itemRequired: (value: number) => value !== 0,
    preferredCompany: (value: number) => this.checkPreferredCompanyEnabled(),
    nameSurname: (value: string) => /^[A-Za-z '-]+$/.test(value.trim()) || 'Name must only contain letters',
    idNumber: (value: string) => (value && value.length > 0) ? /^[0-9]{13}$/.test(value) || 'ID Number must be numeric and 13 characters long' : true, // TODO: @connor - (later) Check with Sean if we want to do proper SA ID Number Validation here https://codeblock.co.za/how-to-validate-a-south-african-id-number-with-php/
    optionalPhone: (value: string) => (value && value.length > 0) ? /^[0-9]{10}$/.test(value) || 'Please enter a valid Phone Number' : true,
    email: (value: string) => /(?:[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(value) || 'E-mail must be valid',
    password: (value: string) => value.length >= 8 || 'At least 8 characters',  
  };

  myInformation: UserInformation = {
    id: 0,
    statusId: 0,
    currentJob: '', // job plans
    jobChangeWanted: false,
    appliedToProgram: false,
    qualificationId: 0,
    preferredCompanyId: 0,
    preferredCompany: '',
    gapPlans: '', // gap plans
    plans: '', // highschool plans
    furtherStudy: false,
    registeredForTeriary: false,
    averageGradeId: 0,
    schoolName: '',
  };

  selectedMark: string = '';
  selectedSubject: string = '';

  // --- Data Table ---
  subjects: SubjectMarkPair[] = [];
  subjectHeaders = [
    { 
      text: 'Subject', 
      value: 'subject',
    },
    { 
      text: 'Grade', 
      value: 'mark',
    },
    {
      sortable: false,
      text: '',
      value: 'action',
      align: 'end',
    },
  ];

  selectedAspectIds: number[] = [];
  
  preferredCompanyList: DisabledIDNamePair[] = [];

  // used by confirm action dialog
  action: string = '';
  dialogContent: string = '';
  showConfirmActionDialog: boolean = false;  
  confirmActionDelay: boolean = false;

  // #region Functions to assist validation

    validateSubjects() {
      if (this.myInformation.statusId === 3 || this.myInformation.statusId === 4 || this.myInformation.statusId === 3) {
        if (this.subjects.length < 7) {
          return true;
        }
        return false;
      }
      return false;
    }

    validateAspects() {
      if (this.myInformation.statusId === 8) {
        if (this.selectedAspectIds.length < 3) {
          return true;
        }
        return false;
      }
      return false;
    }
    
    checkPreferredCompanyEnabled() {
      const selectedCompany = this.preferredCompanyList.find((item: DisabledIDNamePair) => item.id === this.myInformation.preferredCompanyId!);
      return (selectedCompany ? !selectedCompany.disabled : true);
    }

  // #endregion

  // #region Functions to display profile data on page load

    async beforeMount() {
      // get all our static data from the DB
      await AppService.getGenders(false);
      await AppService.getRaces(false);
      await AppService.getLocations(false);
      await AppService.getStatuses(false);
      await AppService.getMarks(false);
      await AppService.getSubjects(false);
      await AppService.getQualifications(false);
      await AppService.getCompanies(false);
      await AppService.getAspects(false);

      await this.getSiteUserProfile();
      await this.getStatusInformation();

      this.clickedItem = this.$store.getters['users/loggedInUser'];
      if (this.clickedItem && this.clickedItem.profile && this.clickedItem.profile.birthDate && this.clickedItem.profile.birthDate.length > 0) {
        this.dateOfBirth = this.clickedItem.profile.birthDate;
      }
      
      // now check if our User has previously selected 8: In Final Year of Studying
      if (this.myInformation.statusId === 8) {
        // make a copy of the company list from store, marking everything coming from store as enabled
        this.preferredCompanyList = this.$store.getters['app/companies'].map((item: IDNamePair) => {
          return { id: item.id, name: item.name, disabled: false};
        });
                
        // now check if the company our user previously selected is in the list
        const index = this.preferredCompanyList.findIndex((item: DisabledIDNamePair) => item.id === this.myInformation.preferredCompanyId!);
        
        if (index < 0) {
          // we did not find the selected company!
          // add it to the custom list as a disabled value so it cannot be reselected
          this.preferredCompanyList.unshift({ id: this.myInformation.preferredCompanyId!, name: this.myInformation.preferredCompany!, 
            disabled: true});
          
          this.$nextTick(() => {
            if (this.$refs.infoForm) {
              (this.$refs.infoForm as any).validate();
            }
          });
        }
      }
    }

    async getSiteUserProfile() {
      try {
        const response = await AuthService.getProfile();
        
        if (response && response.length > 0) {
          // something broke
          AppService.errorHandler(response);
        }

      } catch (error) {

        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          await AuthService.logSupportDebug('UserProfile.vue - getSiteUserProfile - 876 - ' + error);
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }
      }
    }

    async getStatusInformation() {
      try {
        const response = await AuthService.getStatusInformation();

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            AppService.errorHandler(response.data.message);
          } else {
            this.myInformation = response.data;

            // go fetch previously selected subjects if required
            if (this.myInformation.statusId === 3 || this.myInformation.statusId === 11 || this.myInformation.statusId === 4) {
              const response = await AuthService.getSubjectSelection();

              if (response && response.data) {
                if (response.data.result && response.data.result === 'false') {
                  this.subjects = [];
                  //AppService.errorHandler(response.data.message); // no need to tell the User we couldn't get their Subjects
                } else {
                  this.subjects = response.data;
                }
              } else {
                // response is undefined or has no data field - SHOULD NEVER HAPPEN!
                //throw new Error('response: ' + JSON.stringify(response)); // no need to tell the User we couldn't get their Subjects
              }
            }

            // go fetch aspects
            if (this.myInformation.statusId === 8) {
              const response = await AuthService.getAspectSelection();

              if (response && response.data) {
                if (response.data.result && response.data.result === 'false') {
                  this.selectedAspectIds = [];
                  //AppService.errorHandler(response.data.message); // no need to tell the User we couldn't get their Aspects
                } else {
                  this.selectedAspectIds = response.data;
                }
              } else {
                // response is undefined or has no data field - SHOULD NEVER HAPPEN!
                //throw new Error('response: ' + JSON.stringify(response)); // no need to tell the User we couldn't get their Aspects
              }
            }
          }

        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {

        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          await AuthService.logSupportDebug('UserProfile.vue - getStatusInformation - 937 - ' + error);
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }
      }
    }

    addSubject() {
      if (this.subjects.findIndex((item: SubjectMarkPair) => (item.subject === this.selectedSubject)) !== -1) {
        AppService.errorHandler('That Subject is already selected. If you would like to change the mark please delete the subject.');
      } else {
        const selectedSubject: SubjectMarkPair = {
          subject: this.selectedSubject,
          mark: this.selectedMark,
        };

        this.subjects.unshift(selectedSubject);
        this.selectedSubject = '';
        this.selectedMark = '';

        if (this.$refs.subjectForm) {
          (this.$refs.subjectForm as any).resetValidation();
        }
      }
    }

    deleteSubject(selectedItem: SubjectMarkPair) {
      const index = this.subjects.findIndex((item: SubjectMarkPair) => (
        item.subject === selectedItem.subject && item.mark === selectedItem.mark
        ));
      this.subjects.splice(index, 1);
    }

    resetInfoVariables() {
      // thse are the pages that show the subject selection table
      // if the user is going to these pages then we don't want to delete the subjects because they may previous input
      if (!(this.myInformation.statusId === 3 || this.myInformation.statusId === 4 || this.myInformation.statusId === 11)) {
        this.subjects = [];
      }

      // this can be done for each page combination but not sure if it's worth it or this is the correct way to do this
      this.myInformation = {
        id: 0,
        statusId: this.myInformation.statusId,
      };
      this.selectedAspectIds = [];
      

      if (this.$refs.infoForm) {
        (this.$refs.infoForm as any).resetValidation();
      }
      if (this.$refs.subjectForm) {
        (this.$refs.subjectForm as any).resetValidation();
      }
    }

  // #endregion

  // #let's update this users profile

  async updateProfile() {
    try {
      this.updateProfileLoader = true;

      const response = await AuthService.updateProfile({ firstName: this.clickedItem.profile!.firstName,
       surname: this.clickedItem.profile!.surname, idNumber: this.clickedItem.profile!.idNumber, 
       birthDate: this.clickedItem.profile!.birthDate, raceId: this.clickedItem.profile!.raceId,
       genderId: this.clickedItem.profile!.genderId, locationId: this.clickedItem.profile!.locationId,
       cell: this.clickedItem.profile!.cell, email: this.clickedItem.profile!.email,
       wantsNews: this.clickedItem.profile!.wantsNews });

      if (response && response.data) {
        if (response.data.result && response.data.result === 'false') {
          AppService.errorHandler(response.data.message);
        } else {
          AppService.successHandler(response.data.message);
          await AuthService.getLoggedInUser(); // in case they updated their name
          await this.getSiteUserProfile();          
        } 
      } else {
        // response is undefined or has no data field - SHOULD NEVER HAPPEN!
        throw new Error('response: ' + JSON.stringify(response));
      }
    } catch (error) {
      if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          await AuthService.logSupportDebug('UserProfile.vue - updateProfile - 1023 - ' + error);
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }
    } finally {
      this.updateProfileLoader = false;
    }
  }
  
  // #endregion

  // # lets update the users information

    async updateInformation() {
      this.infoValid = true;
      this.updateInfoLoader = true;

      try {
        const response = await AuthService.createUpdateStatusInformation({
          statusId: this.myInformation.statusId,
          currentJob: this.myInformation.currentJob,
          jobChangeWanted: this.myInformation.jobChangeWanted,
          appliedToProgram: this.myInformation.appliedToProgram,
          qualificationId: this.myInformation.qualificationId,
          preferredCompanyId: this.myInformation.preferredCompanyId,
          gapPlans: this.myInformation.gapPlans,
          plans: this.myInformation.plans,
          furtherStudy: this.myInformation.furtherStudy,
          registeredForTeriary: this.myInformation.registeredForTeriary,
          averageGradeId: this.myInformation.averageGradeId,
          schoolName: this.myInformation.schoolName,
          aspectIds: this.selectedAspectIds,
          selectedSubjects: this.subjects,
        });

        if (response.data.result === 'NO') {
          AppService.errorHandler(response.data.message);
        } else {
          AppService.successHandler(response.data.message);
          this.getStatusInformation();
        }

      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {          
          await AuthService.logSupportDebug('UserProfile.vue - updateInformation - 1068 - ' + error);
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }

      } finally {
        this.updateInfoLoader = false;
      }
    }

  // # endregion

  // # reset password
    async resetPassword() {
      this.passwordResetLoader = true;

      try {
        const response = await AuthService.resetPassword();

        if (response.data.result === 'false') {
          AppService.errorHandler(response.data.message);
          // check if we got a multiple email address error:
        } else {
          AppService.successHandler(response.data.message);
        }

      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }

      } finally {
        this.passwordResetLoader = false;
      }
    }

  // #endregion

  // #region 
    launchDeleteConfirmationDialog() {
      this.action = 'DELETE';
      this.dialogContent = '<span style="color: #C01212">This will <span style="font-weight: 700;">DELETE ALL</span> your User Information from the Online Career Guidance Portal '
        + 'and <span style="font-weight: 700;">CAN NOT</span> be undone.'
        + '<br/> <br/> <span style="font-weight: 700;">You will be immediately logged out.</span>'
        + '<br/> <br/> Are you sure?</span>';
      this.showConfirmActionDialog = true;
    }

    ConfirmActionDialog_cancel() {
      this.showConfirmActionDialog = false;
    }

    ConfirmActionDialog_doConfirmed() {
      if (this.action === 'DELETE') {
        this.deleteUser();
      }
    }
    
    async deleteUser() {
      try {
        this.confirmActionDelay = true;
        const response = await AuthService.deleteMe();

        if (response && response.data) {
          if (response.data.result === 'false') {
            AppService.errorHandler(response.data.message);
          } else {
            AppService.successHandler(response.data.message);
            await AuthService.logout();
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.errorHandler(
            this.$store.getters['app/messages'].couldNotConnect,
          );
        }
      } finally {
        this.confirmActionDelay = false;
      }
    }
  // #endregion
}
